import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { Checkbox } from '@/common/components/Inputs/index';

const checkRequired = (arr) => {
  let req = true;
  for (let i = 0; i < arr.length; i++) {
    const item = arr[i];
    if (item !== '' && item !== undefined) {
      req = false;
      break;
    }
  }

  return req;
};

const MultipleInput = ({ options = [], name }) => {
  const { control, watch } = useFormContext();
  const watchSlug = watch(options.map(({ value }) => `${name}.${value}.value`));
  const isRequired = checkRequired(watchSlug);
  return (
    <div>
      {options.map(({ label, value }) => (
        <Controller
          key={`${name}.${value}`}
          name={`${name}.${value}.value`}
          control={control}
          rules={{
            required: isRequired,
          }}
          render={({
            field: { onChange, value: fieldValue, name },
            fieldState: { error },
          }) => {
            return (
              <Checkbox
                name={name}
                onChange={({ target: { checked } }) =>
                  onChange(checked ? value : '')
                }
                label={label}
                withForm={false}
                checked={!!fieldValue}
                error={error}
              />
            );
          }}
        />
      ))}
    </div>
  );
};

export default MultipleInput;
